<template>
    <nav class="c-sidenavigation">
        <CultureAwareRouterLink v-if="activeRootMenuItem"
                                :to="activeRootMenuItem?.url"
                                class="text-14 md:text-16 mb-5 md:mb-10 font-medium hover:underline">
            <span>{{ activeRootMenuItem?.name }}</span>
        </CultureAwareRouterLink>
        <NavigationTree v-for="menuItem in navigationItems" :key="menuItem.id"
                        class="font-medium"
                        :menu-item="menuItem"
                        :selected-menu-item="activeMenu"
                        use-route-navigation/>
    </nav>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { BreadcrumbItem, NavigationItem } from '@/types/contentServerContract';
import appStore from '@/core/app/app.store';

const props = defineProps({
    navigationItems: {
        type: Array as PropType<NavigationItem[]>,
        required: true
    }
});

const breadCrumbItems = computed(() => {
    const breadCrumbItems = appStore.breadcrumb ?? null;
    return breadCrumbItems.length > 0 ? breadCrumbItems : null;
});

const activeRootMenuItem = computed((): BreadcrumbItem | null => {
    if (!breadCrumbItems.value) return null;
    return breadCrumbItems.value?.length ? breadCrumbItems.value[0] : null;
});

const activeMenu = computed((): NavigationItem | null => {
    const activeBreadcrumbUrl = breadCrumbItems.value?.[breadCrumbItems.value.length - 1]?.url;
    if (!activeBreadcrumbUrl) {
        return null;
    }

    return findNavigationItemByUrl(props.navigationItems, activeBreadcrumbUrl);
});

function findNavigationItemByUrl(items: NavigationItem[], url: string): NavigationItem | null {
    for (const item of items) {
        if (item.url === url) {
            return item;
        }

        const childMatch = findNavigationItemByUrl(item.children, url);
        if (childMatch) {
            return childMatch;
        }
    }

    return null;
}
</script>
